export default __webpack_public_path__ + "static/media/paper.7b8828dd.svg";